import { Schema as S } from "effect";

export const CalendarConsultTimeSchema = S.Struct({
  publicInsurance: S.Boolean,
  privateInsurance: S.Boolean,
  end: S.Tuple([S.Int, S.Int]),
  start: S.Tuple([S.Int, S.Int]),
  colorOfConsults: S.String,
  days: S.Array(S.Int),
});

export const CalendarResourceSchema = S.Struct({
  _id: S.String,
  resourceType: S.String,
  resource: S.String,
});

export const CalendarSchema = S.Struct({
  _id: S.String,
  name: S.String,
  descr: S.optional(S.String),
  isPublic: S.optional(S.Boolean),
  isShared: S.optional(S.Boolean),
  calGroup: S.optional(S.Array(S.String)),
  isRandomMode: S.optional(S.Boolean),
  type: S.Union(
    [S.Literal("INFORMAL"),
    S.Literal("DUTIES"),
    S.Literal("PATIENTS"),
    S.Literal("INTRESOURCES"),
    S.Literal("EXTRESOURCES"),
    S.Literal("WITHOUT_ASSIGNMENT")],
  ),
  employee: S.optional(S.String),
  locationId: S.optional(S.String),
  color: S.String,
  isPartnerCalendar: S.optional(S.Boolean),
  dcCustomerNo: S.optional(S.String),
  mirrorCalendarId: S.optional(S.String),
  consultTimes: S.optional(S.Array(CalendarConsultTimeSchema)),
  resources: S.optional(S.Array(CalendarResourceSchema)),
});

export const ListCalendarsMetaSchema = S.Struct({
  errors: S.Array(S.Unknown),
  warnings: S.Array(S.Unknown),
  query: S.Record(S.String, S.Unknown),
  itemsPerPage: S.NullOr(S.Number),
  totalItems: S.Int,
  page: S.NullOr(S.Number),
  replyCode: S.Int,
  model: S.Literal("calendar"),
});

export const ListCalendarsResponseSchema = S.Array(CalendarSchema);

export type ListCalendarsResponse = S.Schema.Type<typeof ListCalendarsResponseSchema>;
